var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrevinline = function SvgPrevinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    transform: "rotate(180)",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "current",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M9.734 20.005H30.05m-8.349-8.67 8.999 8.67-8.999 8.66m17.677-8.66c0 10.582-8.579 19.16-19.161 19.16s-19.16-8.578-19.16-19.16S9.634.844 20.216.844s19.16 8.578 19.16 19.16Z"
  })));
};
export default SvgPrevinline;